import { useQuery } from '@tanstack/react-query';
import { memoriesApi } from '../api';

export const useMemoryStats = () => {
  return useQuery({
    queryKey: ['memories', 'stats'],
    queryFn: () => memoriesApi.getStats(),
  });
};
